import { Navigate, Outlet } from "react-router-dom";
import SideBar from "./SideBar";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useSelector } from "react-redux";
import AboutThisProject from "./AboutThisProject";

function Layout() {
  const user = useSelector((state) => state.user);
  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="d-flex w-100 h-100">
      <AboutThisProject />
      <SideBar />

      <div className="table-responsive w-100">
        <NavBar className="w-100" />
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
